import { combineReducers } from "redux";
import * as types from "./types";
import { createReducer } from "../../utils";

const listReducer = createReducer([])({
    [types.FETCH_CUSTOMER_LIST_COMPLETED]: (state, action) => {
        return action.payload.payload
    },
    [types.UPDATE_COMPLETED]: (state, action) => {
        const note = action.payload
        return note
    }
});

export default combineReducers({
    list: listReducer
});